import { render, staticRenderFns } from "./CopyField.vue?vue&type=template&id=1c007f70&scoped=true&"
import script from "./CopyField.vue?vue&type=script&lang=js&"
export * from "./CopyField.vue?vue&type=script&lang=js&"
import style0 from "./CopyField.vue?vue&type=style&index=0&id=1c007f70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c007f70",
  null
  
)

export default component.exports